import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { IPulseRecord, IPulseResponse, PulseMessageConsoleDisplayType } from '../hardware/_models/IPulseRecord';
import './developer-console.component.scss';
import { LogLevel } from './log-level.enum';
import { ILogMessage } from './log-message.model';
import { FtCloudTelemetryState } from './models/ft-cloud-telemetry-state';
import { SignalRService, WebSocketEvents } from './signalr.service';
import { StreamaxRawService } from './streamax-raw.service';

@Component({
    selector: 'developer-console',
    template: require('./developer-console.component.html')
})
export class DeveloperConsoleComponent implements OnInit {
    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly streamaxRawService: StreamaxRawService,
        private readonly signalRService: SignalRService) { }

    logMessageReceived = new Subject<ILogMessage>();
    tachoReceived = new Subject<any>();
    pulseMessageReceived = new Subject<IPulseRecord>();
    pulseResponseReceived = new Subject<IPulseResponse>()

    logMessages: ILogMessage[] = [];
    streamaxLogMessages: ILogMessage[] = [];
    pulseMessages: (IPulseRecord | IPulseResponse)[] = [];
    tachoMessages: any[] = [];

    logLevel = LogLevel;

    serial = "303213121024"

    telemetryStates: FtCloudTelemetryState[] = [];

    async ngOnInit(): Promise<void> {}

    joinGroup(): void {
        this.signalRService.joinDeviceGroup(this.serial)
    }

    clearData(): void {
        this.pulseMessages = [];
        this.logMessages = [];
        this.tachoMessages = [];
    }

    serialChanged(serial: string): void {
        this.serial = serial;
    }

    isPulseRecord(item: IPulseRecord | IPulseResponse): item is IPulseRecord {
        return item.consoleDisplayType === PulseMessageConsoleDisplayType.Record;
    }

    isPulseResponse(item: IPulseRecord | IPulseResponse): item is IPulseResponse {
        return item.consoleDisplayType === PulseMessageConsoleDisplayType.Response;
    }

    async refreshStreamaxStates(): Promise<void> {
        this.telemetryStates = await this.streamaxRawService.getEndpointsStates();
    }

    async toggleStreamaxState(functionType: number): Promise<void> {
        await this.streamaxRawService.toggleState(functionType);

        const state = this.telemetryStates.find(x => x.FunctionType === functionType);
        state.IsEnabled = !state.IsEnabled;
    }

    private initSignalR(): void {
        this.signalRService.initialise().then(() => {
            this.signalRService.joinDeviceGroup(this.serial);
            this.signalRService.registerEvents<ILogMessage>(WebSocketEvents.LogMessage, this.logMessageReceived);
            this.signalRService.registerEvents<any>(WebSocketEvents.Tacho, this.tachoReceived);
            this.signalRService.registerEvents<any>(WebSocketEvents.Pulse, this.pulseMessageReceived);
            this.signalRService.registerEvents<any>(WebSocketEvents.CameraCommand, this.pulseResponseReceived);
        });

        this.logMessageReceived.subscribe((message) => {
            console.log("Log Message received:", message);

            if (message.Message.startsWith("STREAMAX-")) {
                this.streamaxLogMessages.push({...message, Value: JSON.parse(message.Value)});
            } else {
                this.logMessages.push(message);
            }

            this.cd.detectChanges();
        });

        this.tachoReceived.subscribe((message) => {
            console.log("Tacho Message received:", message);
            this.tachoMessages.push(JSON.parse(message));
            this.cd.detectChanges();
        });

        this.pulseMessageReceived.subscribe((message) => {
            console.log("Pulse Message received:", message);

            message.consoleDisplayType = PulseMessageConsoleDisplayType.Record;

            this.pulseMessages.push(message);
            this.cd.detectChanges();
        });

        this.pulseResponseReceived.subscribe((message) => {
            console.log("Pulse Response received", message);

            message.consoleDisplayType = PulseMessageConsoleDisplayType.Response;

            this.pulseMessages.push(message);
            this.cd.detectChanges();
        });
    }
}
